// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicator_wrapper__3w3Dt","loaderContainer":"LoadingIndicator_loaderContainer__3OqqV"};